class HeaderMenu extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector(".header__inline-menu > ul");
        this.mainItemDetails = this.querySelector(
            "[data-main-item-menu] details"
        );
        this.itemsDetails = this.querySelectorAll("[data-items-menu] details");
        this.overlay = document.querySelector(".header-menu__overlay-element");

        /* dropdown-inner  - remove redundant item images. Allow to show only one Item-Image per Dropdown Inner */
        const dropdownInner = this.querySelectorAll(
            ".dropdown-inner.full-width"
        );
        this.container && dropdownInner
            ? this.removeOddItemImages(dropdownInner)
            : "";

        this.querySelectorAll("details-disclosure > details").forEach(
            (detail) => {
                if (this.container.dataset?.activateMenu == "on_click") {
                    // activate top level items on hover
                    detail.addEventListener(
                        "click",
                        this.activateTopLevelOnClick.bind(this)
                    );
                } else {
                    // activate top level items on hover - default behavior
                    detail.addEventListener(
                        "mousestop",
                        this.activateTopLevelOnHover.bind(this)
                    );
                    detail.addEventListener(
                        "mouseleave",
                        debounce(this.mouseLeave.bind(this), 200)
                    );
                }

                // highlight top level items when its child active
                this.highlightParentItemOnActiveChild(detail);
            }
        );

        if (!this.itemsDetails.length) return;

        this.itemsDetails.forEach((detail) => {
            /* megamenu - open dropdown inner always */
            if (detail.lastElementChild.dataset.typeMenu == "full-width") {
                detail.setAttribute("open", true);
            }
        });
    }

    activateTopLevelOnClick(e) {
        let detail = e.target.closest("details"),
            summary = e.target.closest("summary"),
            topLevelItems = this.container.querySelectorAll(
                "details-disclosure > details > summary > a"
            );

        // remove active class from all items
        topLevelItems.forEach((item) => {
            item.classList.remove("list-menu__item--active");
        });

        if (detail.parentElement.nodeName === "DETAILS-DISCLOSURE") {
            e.preventDefault();
            detail.setAttribute("open", true);

            // highlight the active menu item
            summary?.children[0].classList.add("list-menu__item--active");

            e.stopPropagation();
        }
    }

    activateTopLevelOnHover(e) {
        let detail = e.target.closest("details");

        /* first item of small menu uses separate event */
        if (detail.parentElement.parentElement.dataset.mainItemMenu) {
            this.container.style.overflow = "visible";
            this.mouseOver(detail);
            return;
        }

        if (detail.parentElement.nodeName === "DETAILS-DISCLOSURE") {
            detail.setAttribute("open", true);
        }
    }

    getLiWidthMainListMenu(lis) {
        let liWidth = [];
        lis.forEach((li, i) => {
            liWidth[i] = parseInt(li.offsetWidth, 10);
        });

        return liWidth.reduce((acc, curVal) => acc + curVal, 0);
    }

    showOverlay() {
        if (this.overlay.style.display == "")
            this.overlay.style.display = "block";

        if (!this.overlay.classList.contains("shown"))
            setTimeout(() => {
                this.overlay.classList.add("shown");
            }, 100);
    }

    removeOverlay() {
        this.overlay.classList.remove("shown");
        setTimeout(() => {
            this.overlay.style.display = "";
        }, 200);
    }

    getSubMenuHeight(submenu) {
        this.subMenuHeight =
            submenu.getBoundingClientRect().bottom -
            submenu.getBoundingClientRect().top;
        return this.subMenuHeight;
    }

    setMinHeight(detail) {
        let childListsMenu = detail.querySelectorAll(
            ".childlist-menu--disclosure"
        );

        /* set childlist height as submenu height */
        if (
            !childListsMenu.length ||
            !detail.parentElement.parentElement.dataset.mainItemMenu
        )
            return;

        childListsMenu.forEach((childList) => {
            childList.style.minHeight = this.subMenuHeight
                ? `${this.subMenuHeight}px`
                : `${this.getSubMenuHeight(detail.querySelector("ul"))}px`;
        });
    }

    mouseOver(detail) {
        detail.querySelectorAll("details").forEach((childDetail) => {
            /* show overlay only for main (first) small item menu */
            if (detail.parentElement.parentElement.dataset.mainItemMenu)
                this.showOverlay();

            childDetail.addEventListener("mouseover", (evt) => {
                this.mouseOver(childDetail);
            });
            childDetail.addEventListener(
                "mouseleave",
                this.mouseChildLeave.bind(this)
            );
        });

        detail.setAttribute("open", true);
        this.setMinHeight(detail);
    }

    mouseLeave(event) {
        let detail = event.target;
        if (
            detail.parentElement.parentElement.closest("ul.submenu-nowrap") !==
            null
        )
            return;

        this.subMenuHeight = false;
        detail.removeAttribute("open");
        if (
            detail.parentNode.closest("li").hasAttribute("data-main-item-menu")
        ) {
            this.removeOverlay();
        }
    }

    mouseChildLeave(event) {
        /* first item of small menu */
        this.subMenuHeight = false;
        if (event.target.hasAttribute("open")) {
            setTimeout(() => {
                event.target.removeAttribute("open");
            }, 200);
        }
    }

    removeOddItemImages(dropdownInner) {
        dropdownInner.forEach((item) => {
            let el = item.children[0];
            if (el && el.childNodes.length > 2) {
                let childs = el.children;
                for (var i in childs) {
                    if (i > 1 && childs[i])
                        childs[i].classList.add("odd-image-item");
                }
            }
            /* use extra class to update dropdown width with item-image */
            if (el && el.children[1]) {
                el.classList.add("inner--with-image");
            }
        });

        document.querySelectorAll(".odd-image-item").forEach((item) => {
            item.remove();
        });
    }

    highlightParentItemOnActiveChild(detail) {
        /* Highlight the first menu item permanently enabled */
        if (this.container.firstChild.dataset.linkHighlighted == "true") return;

        let dropdownInner = detail.children[1],
            activeChild = dropdownInner.querySelector(
                ".list-menu__item--active"
            );

        if (activeChild)
            detail.parentElement.parentElement.classList.add(
                "highlite_parent_item_on_active_child"
            );
        else
            detail.parentElement.parentElement.classList.remove(
                "highlite_parent_item_on_active_child"
            );
    }
}

customElements.define("header-menu", HeaderMenu);

/* create custom event for better behavior on top level mouseover */
(function (mouseStopDelay) {
    var timeout;
    document.addEventListener("mouseover", function (e) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            var event = new CustomEvent("mousestop", {
                detail: {
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
                bubbles: true,
                cancelable: true,
            });
            e.target.dispatchEvent(event);
        }, mouseStopDelay);
    });
})(150);
